import x from "../../../assets/images/X.png";
import { useTranslation } from "react-i18next";
import { Modal } from "react-bootstrap";
import Search1 from "../../../assets/images/Search1.png";
import Previous from "../../../assets/images/Previous.png";

import { useLocation, useNavigate } from "react-router-dom";
import {
  SetSearch,
  SetTypeMenu,
} from "../../../features/TopSearches/TopSearchesSlice";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import {
  SetSelectdPage,
  SetSizeFilter,
  SetTopSizeFilter,
  resetLoadingNumber,
  SortProducts,
  SetBottomSizeFilter,
  getAllProductOnline,
} from "../../../features/Products/ProductSlice";
import NotificationModal from "../NotificationModal";
import SearchMenuSection2 from "./SearchMenuSection2";
import SeacrhMenuDesigners from "./SeacrhMenuDesigners";
import SeacrhMenuWomen from "./SeacrhMenuWomen";
import { useEffect } from "react";

function SearchMenuModal({ show, setShow, id, setSeacrhDrop }) {
  const { i18n, t } = useTranslation();
  const { searchQuary, type } = useSelector((store) => store.topsearches);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [sq, setsq] = useState("");
  // const [type, dispatch(SetTypeMenu] = useState('')
  let parametres = new URLSearchParams(useLocation().search);

  function handleSearch(event) {
    if (event.key === "Enter" || event.key === "Done") {
      setsq(event.target.value);
      dispatch(getAllProductOnline([]));
      dispatch(SetSearch(event.target.value));
      dispatch(SetSizeFilter([]));
      dispatch(SetTopSizeFilter([]));
      dispatch(SetSelectdPage(0));
      dispatch(SetSizeFilter([]));
      dispatch(SetBottomSizeFilter([]));
      dispatch(resetLoadingNumber(30));
      // if (parametres.get('topic') != null)
      // { navigate(`/products?topic=${parametres.get('topic')}`) }
      // else {
      navigate("/products");
      // }
    } else {
      setsq(event.target.value);
      //console.log(event.target.value);
      //dispatch(SetSearch(event.target.value));
    }
  }
  function handleSubmitSearch(event) {
    //alert(sq)
    dispatch(getAllProductOnline([]));
    dispatch(SetSearch(sq));
    setSeacrhDrop(false);
    dispatch(SetSelectdPage(0));
    sessionStorage.setItem("selectedItemIndex", "");
    dispatch(resetLoadingNumber(30));
    dispatch(SortProducts(""));
    dispatch(SetSizeFilter([]));
    dispatch(SetTopSizeFilter([]));
    dispatch(SetBottomSizeFilter([]));
    //console.log(searchQuary);
    // if (parametres.get('topic') != null)
    // { navigate(`/products?topic=${parametres.get('topic')}`) }
    // else {
    navigate("/products");
    // }
    setShow(false);
  }
  const handleTheSearch = () => {
    dispatch(SetSearch(sq));
    navigate("/products");
    setShow(false);
  };
  const [showsection2, setShowSection2] = useState(false);
  const [showsectiondesigner, setShowSectionDesigner] = useState(false);
  const [showsectionwomen, setShowSectionWomen] = useState(false);
  useEffect(() => {
    dispatch(SetSelectdPage(0));
  }, []);
  return (
    <>
      {showsection2 && (
        <SearchMenuSection2
          show={showsection2}
          setShow={setShowSection2}
          type={type}
          setShowfirst={setShow}
        />
      )}
      {showsectiondesigner && (
        <SeacrhMenuDesigners
          showsectiondesigner={showsectiondesigner}
          setShowSectionDesigner={setShowSectionDesigner}
          type={type}
          setShowfirst={setShow}
        />
      )}
      {showsectionwomen && (
        <SeacrhMenuWomen
          show={showsectionwomen}
          setShow={setShowSectionWomen}
          type={type}
          setShowfirst={setShow}
        />
      )}
      <Modal
        // className="modal fade"
        // id="SignUp"
        // tabIndex="-1"
        // role="dialog"
        // aria-labelledby="SignUp"
        show={show}
        fullscreen
        className="modal fade mx-0 px-0"
      >
        {/* <div
          className="modal-dialog modal-dialog-centered modal-signup"
          role="document"
        > */}
        <Modal.Body className="p-0 m-0 ">
          <div className="modal-header justify-content-end d-flex pb-0">
            <button
              type="button"
              className="close close-txt close-modal align-items-center px-0"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => setShow(false)}
            >
              <img
                alt="main"
                src={x}
                onClick={() => setShow(false)}
                className="x-close  mb-1"
              />

              {/* <img src={closeModal} onClick={()=>setShow(false)} className="ms-1 mb-1 close-btn2"/> */}
            </button>
          </div>

          <div className="modal-body px-4">
            {/* <div className="row mx-0">
              <div className="col-10 px-0 pe-4"> */}
            <div className="search position-relative">
              <img
                src={Search1}
                className="fa-search-brand2"
                alt="Search designer brand"
              />
              <form onSubmit={handleSubmitSearch}>
                <input
                  type="search"
                  enterkeyhint="search"
                  className={`form-control search-brand3 pb-2 ${
                    i18n.language === "en" ? "ps-4" : "pe-4"
                  }`}
                  placeholder={t("placeholderSeacrh")}
                  onChange={handleSearch}
                  value={sq}
                  //value={sq.length==0?searchQuary:sq}
                />
              </form>
            </div>
            {/* </div> */}
            <div
              className="w-100 pt-2 pt-4 pb-4 px-0 align-items-center d-flex justify-content-between"
              onClick={() =>
                setShowSection2(true) & dispatch(SetTypeMenu("newdrops"))
              }
              style={{ cursor: "pointer" }}
            >
              <div className="searchmenu">{t("drops")}</div>
              <div>
                <img
                  src={Previous}
                  alt="Previous"
                  className={` ${
                    i18n.language == "en" ? "Previous" : "PreviousAr"
                  }`}
                />
              </div>
            </div>
            <div
              className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
              onClick={() =>
                setShowSectionDesigner(true) &
                dispatch(SetTypeMenu("Designers"))
              }
              style={{ cursor: "pointer" }}
            >
              <div className="searchmenu">{t("Designers")}</div>
              <div>
                <img
                  src={Previous}
                  alt="Previous"
                  className={` ${
                    i18n.language == "en" ? "Previous" : "PreviousAr"
                  }`}
                />
              </div>
            </div>
            <div
              className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
              onClick={() =>
                setShowSection2(true) & dispatch(SetTypeMenu("Women"))
              }
              style={{ cursor: "pointer" }}
            >
              <div className="searchmenu">{t("Women")}</div>
              <div>
                <img
                  src={Previous}
                  alt="Previous"
                  className={` ${
                    i18n.language == "en" ? "Previous" : "PreviousAr"
                  }`}
                />
              </div>
            </div>
            <div
              className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
              onClick={() =>
                setShowSection2(true) & dispatch(SetTypeMenu("Men"))
              }
              style={{ cursor: "pointer" }}
            >
              <div className="searchmenu">{t("Men")}</div>
              <div>
                <img
                  src={Previous}
                  alt="Previous"
                  className={` ${
                    i18n.language == "en" ? "Previous" : "PreviousAr"
                  }`}
                />
              </div>
            </div>
            <div
              className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
              onClick={() =>
                setShowSection2(true) & dispatch(SetTypeMenu("Bags"))
              }
              style={{ cursor: "pointer" }}
            >
              <div className="searchmenu">{t("Bags")}</div>
              <div>
                <img
                  src={Previous}
                  alt="Previous"
                  className={` ${
                    i18n.language == "en" ? "Previous" : "PreviousAr"
                  }`}
                />
              </div>
            </div>
            <div
              className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
              onClick={() =>
                setShowSection2(true) & dispatch(SetTypeMenu("Shoes"))
              }
              style={{ cursor: "pointer" }}
            >
              <div className="searchmenu">{t("Shoes")}</div>
              <div>
                <img
                  src={Previous}
                  alt="Previous"
                  className={` ${
                    i18n.language == "en" ? "Previous" : "PreviousAr"
                  }`}
                />
              </div>
            </div>
            <div
              className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
              onClick={() =>
                setShowSection2(true) & dispatch(SetTypeMenu("vintage"))
              }
              style={{ cursor: "pointer" }}
            >
              <div className="searchmenu">{t("vintage")}</div>
              <div>
                <img
                  src={Previous}
                  alt="Previous"
                  className={` ${
                    i18n.language == "en" ? "Previous" : "PreviousAr"
                  }`}
                />
              </div>
            </div>
            <div
              className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
              style={{ cursor: "pointer" }}
            >
              <div
                className="searchmenu"
                onClick={() =>
                  window.location.assign("https://libas.page.link/welcome")
                }
              >
                {t("Become a Seller")}
              </div>
            </div>
            <div
              className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
              style={{ cursor: "pointer" }}
            >
              <div
                className="searchmenucrypt"
                onClick={() => navigate("/all-blogs")}
              >
                {t("THE")} {t("CRYPT")}
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default SearchMenuModal;
